import { ShoppingCart, X } from "@phosphor-icons/react";
import { toast } from "sonner";

const TAG = "boulevardie0d-21";

export const buildCartUrl = (asins) => {
  const parts = asins.map((a, i) => `ASIN.${i + 1}=${encodeURIComponent(a)}&Quantity.${i + 1}=1`);
  return `https://www.amazon.co.uk/gp/aws/cart/add.html?AssociateTag=${TAG}&${parts.join("&")}`;
};

const openTab = (url) => {
  const w = window.open(url, "_blank");
  if (w) w.opener = null;
  return !!w;
};

export const AmazonBulkBar = ({ selectedItems, total, onSelectAll, onClear, onCancel, oneBasket }) => {
  const basketItems = oneBasket ? selectedItems.filter((i) => i.asin) : [];
  const searchItems = selectedItems.filter((i) => !basketItems.includes(i));

  const openAll = () => {
    let blocked = 0;
    if (basketItems.length && !openTab(buildCartUrl(basketItems.map((i) => i.asin)))) blocked += 1;
    searchItems.forEach((it) => { if (!openTab(it.amazon_url)) blocked += 1; });
    if (blocked) toast.warning(`Your browser blocked ${blocked} tab${blocked === 1 ? "" : "s"} — allow pop-ups for this site and try again`);
    else if (basketItems.length) toast.success(`${basketItems.length} item${basketItems.length === 1 ? "" : "s"} added to one Amazon basket${searchItems.length ? ` · ${searchItems.length} opened as searches` : ""}`);
    else toast.success(`Opened ${selectedItems.length} item${selectedItems.length === 1 ? "" : "s"} on Amazon`);
  };

  return (
    <div className="sticky top-2 z-20 mb-4 rounded-xl bg-rf-ink text-white px-4 py-3 shadow-xl" data-testid="amazon-bulk-bar">
      <div className="flex flex-wrap items-center gap-3">
        <ShoppingCart size={20} weight="duotone" className="text-rf-amber" />
        <span className="text-sm font-bold" data-testid="amazon-bulk-count">{selectedItems.length} of {total} selected</span>
        <button onClick={onSelectAll} data-testid="amazon-bulk-select-all" className="text-xs underline hover:text-rf-amber">Select all</button>
        <button onClick={onClear} data-testid="amazon-bulk-clear" className="text-xs underline hover:text-rf-amber">None</button>
        <div className="ml-auto flex items-center gap-2">
          <button
            onClick={openAll}
            disabled={!selectedItems.length}
            data-testid="amazon-bulk-open"
            className="btn-orange !py-2 !px-4 text-sm disabled:opacity-40"
          >
            {basketItems.length ? "Add to one Amazon basket" : "Buy selected on Amazon"}
          </button>
          <button onClick={onCancel} aria-label="Cancel Amazon selection" data-testid="amazon-bulk-cancel" className="p-1 hover:text-rf-amber"><X size={18} /></button>
        </div>
      </div>
      {oneBasket && selectedItems.length > 0 && (
        <p className="text-xs text-white/70 mt-2" data-testid="amazon-bulk-basket-note">
          {basketItems.length} go straight into one basket{searchItems.length ? ` · ${searchItems.length} without an exact product open as searches (tip: paste an Amazon product link into "Pick")` : ""}
        </p>
      )}
    </div>
  );
};
